import moment from 'moment';

import { IApiError } from '../models/api';

export const getHebrewDate = (date: Date | string) =>
  moment(date).format('DD/MM/YYYY');

export const getDateAndTime = (value: Date | string) => {
  const date = new Date(value)
    ?.toLocaleDateString('he-IL')
    ?.replace(/[.]/g, '/');
  const time = moment(value).format('H:mm');

  return `${time} ${date}`;
};

export const getDateTimeAndSeconds = (value: Date | string): string => {
  const endOfDay = value.toString().split('T')[1]?.includes('23:59:59');

  const date = moment(value)
    .subtract({ hours: endOfDay ? 3 : 0 })
    .format('DD/MM/YYYY');

  const time = moment(value)
    .subtract({ hours: endOfDay ? 3 : 0 })
    .format('H:mm:ss');

  if (date == '01/01/0001') return '';

  return `${time} ${date}`;
};

export const getOnlyDate = (date: Date | string) => new Date(date);

export const getFutureDateByNumOfDays = (date: Date, numOfDays: number) => {
  date = getOnlyDate(date);
  return new Date(new Date(date).setDate(new Date(date).getDate() + numOfDays));
};

export const getCorrectDate = (
  date: Date | any = new Date(),
  getFullDate: boolean = false,
  getStartOfDay: boolean = false,
  numOfDays: number
) => {
  if (getStartOfDay) {
    date = getOnlyDate(date);
  }

  date = moment(date, 'DD/MM/YYYY').toDate();

  if ((getFullDate && numOfDays) || numOfDays) {
    date = getFutureDateByNumOfDays(date, numOfDays);

    date = new Date(new Date(date).getTime() - 1000);
  }

  const targetDate: string = date.toISOString();
  return targetDate;
};

export const combinedDateTime = (selectedDate: Date, selectedTime: Date) => {
  const combinedDateTime = new Date(selectedDate);
  combinedDateTime.setHours(selectedTime.getHours());
  combinedDateTime.setMinutes(selectedTime.getMinutes());
  combinedDateTime.setSeconds(selectedTime.getSeconds());
  return combinedDateTime.toISOString();
};

export const sortDataByDate: any = (value1: any, value2: any) => {
  const format = (val: any) => {
    return val.includes(':') ? 'DD/MM/YYYY kk:mm:ss' : 'DD/MM/YYYY';
  };

  if (value1) {
    const value1DayAndTime = value1.split(' ');
    value1 = value1DayAndTime[1] + ' ' + value1DayAndTime[0];

    value1 = moment(value1, format(value1)).toDate();
  }

  if (value2) {
    const value2DayAndTime = value2.split(' ');
    value2 = value2DayAndTime[1] + ' ' + value2DayAndTime[0];

    value2 = moment(value2, format(value2)).toDate();
  }

  return value1 - value2;
};

export const getCorrectPhoneNumber = (phoneNumber: string | undefined) => {
  if (!phoneNumber) return '';

  phoneNumber = phoneNumber.replace('+9720', '0');
  phoneNumber = phoneNumber.replace('+972', '');
  phoneNumber = phoneNumber.replace('-', '');

  return phoneNumber;
};

export const tryParseValue = (value: any) => {
  try {
    return JSON.parse(value);
  } catch (e) {
    return value;
  }
};

export const getErrorMessages = (error: any) => {
  const status = error?.response?.status;
  if (status && [404, 401].includes(status)) {
    return null;
  }
  const { errors = [] }: { errors: IApiError[] | [] } =
    error?.response?.data ?? {};

  if (errors.length) {
    return errors;
  }

  let parsedError: string | IApiError[] = '';

  if (error.message) {
    parsedError = tryParseValue(error.message);
  }

  if (status === 400) {
    let obj = error?.response?.data.errors;
    let errors: IApiError[] = [];

    if (process.env.REACT_APP_ENV === 'dev') {
      for (let key in obj[Object.keys(obj)[0]]) {
        errors.push({ code: -1, message: obj[Object.keys(obj)[0]][key] });
      }
    } else {
      errors.push({ code: -1, message: 'שגיאה כללית' });
    }

    parsedError = errors;
  }

  if (Array.isArray(parsedError) && parsedError.length) {
    if (
      typeof parsedError[0] === 'object' &&
      parsedError[0].hasOwnProperty('code') &&
      parsedError[0].hasOwnProperty('message')
    ) {
      return parsedError;
    }
  }

  return null;
};

export const getNewErrorsArray = (
  errors: IApiError[] | null,
  message: string
) => {
  let newErrors = errors ? [...errors] : null;

  if (newErrors) {
    const foundErrorMessageIndex = newErrors.findIndex(
      (err) => err.message === message
    );

    if (foundErrorMessageIndex > -1) {
      newErrors.splice(foundErrorMessageIndex, 1);

      if (!newErrors.length) {
        newErrors = null;
      }
    }
  }

  return newErrors;
};

export const onlyDigits = (value: string) => /^[0-9]*$/.test(value);

export const onlyLetters = (value: string) => /^[a-z A-Zא-ת]+$/.test(value);
